<script setup lang="ts">
import { computed } from 'vue';
import { DEFAULT_DATE_LOCALE } from '@peanuds/shared';

const { row } = defineProps<{ row: { lastActivity?: string } }>();

const formatter = new Intl.DateTimeFormat(DEFAULT_DATE_LOCALE, {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

const formatted = computed(() => {
  if (!row.lastActivity) return '-';
  const parsed = new Date(row.lastActivity);
  if (Number.isNaN(parsed.getTime())) return '-';
  return formatter.format(parsed);
});
</script>

<template>
  <span class="cell-last-activity">{{ formatted }}</span>
</template>
